import styled from 'styled-components';
import { Chip } from '@mui/material';
import colors from '../../../../../../../styles/colors';
import Button from '../../../../../../../components/Button';

const BASSectionContainer = styled.div`
  margin: 0px 25px 7px 25px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BASChip = styled(Chip)`
  background-color: ${(props) => props.backgroundcolor};
  color: white;
  font-weight: bold;
  padding: 0 5px;
  font-size: small;

  .MuiCircularProgress-root {
    color: black;
  }

  .MuiChip-label {
    padding-right: ${(props) => (props.$hasScore ? '0' : '12px')};
  }
`;

const LoadingBASChip = styled(BASChip)`
  justify-content: center;
  background-color: ${colors.shades.gamma1};
`;

const StyledFeedbackButton = styled(Button)`
  padding: 5px 0px;
  background-color: transparent;
  width: 30px;
  margin-left: 2.5px;
  border-radius: 8px; 
  cursor: pointer;
`;

const StyledChipLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export {
  BASSectionContainer,
  BASChip,
  LoadingBASChip,
  StyledFeedbackButton,
  StyledChipLabel,
};
